import { Suspense } from "react";
import { Outlet } from "react-router-dom";
import { ErrorBoundary } from "@sentry/react";
import { SidebarProvider } from "@/components/ui/sidebar";
import { AppSidebar } from "./AppSidebar";
import { NotificationCenter } from "./NotificationCenter";
import { LanguageSwitcher } from "@/components/LanguageSwitcher";
import { AdminErrorFallback } from "./AdminErrorFallback";
import { useTranslation } from "react-i18next";
import { SwedbankStaffReturnSync } from "@/components/payments/SwedbankStaffReturnSync";

export function AdminLayout() {
  const { t } = useTranslation("admin");
  return (
    <SidebarProvider defaultOpen>
      <div className="flex min-h-screen w-full">
        <AppSidebar />

        <main className="flex-1 flex flex-col min-w-0">
          <header className="sticky top-0 z-40 bg-card/95 backdrop-blur-sm border-b">
            <div className="flex items-center justify-between px-4 md:px-6 h-14">
              <div className="flex items-center gap-3">
                <div className="hidden md:block">
                  <h1 className="text-lg font-semibold">{t("header.title")}</h1>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <LanguageSwitcher />
                <NotificationCenter />
              </div>
            </div>
          </header>

          {/* Content */}
          <div className="flex-1 overflow-auto">
            <SwedbankStaffReturnSync />
            <ErrorBoundary fallback={<AdminErrorFallback />}>
              <Suspense
                fallback={
                  <div className="p-6 text-sm text-muted-foreground">
                    Loading…
                  </div>
                }
              >
                <Outlet />
              </Suspense>
            </ErrorBoundary>
          </div>
        </main>
      </div>
    </SidebarProvider>
  );
}
